import { Brand } from "../models/brand";
import BaseService from "./_base.service";

const endpoint = "brands";

const BrandService = {
  ...BaseService<Brand>({ endpoint }),
};

export default BrandService;
